import type {ESearch, ESearchRequest} from '@local/elastic/eSearch';
import type {EIndexName} from '@local/elastic/searchTypes';
import type {TransportRequestOptionsWithOutMeta} from '@elastic/elasticsearch';
import {TokenGetInteractor} from '@local/logics/interactors/tokenGetInteractor';
import axios from 'axios';
import type {SearchResponse} from '@elastic/elasticsearch/lib/api/types';

/**
 * useSearchの役割を変えて退避させたらあとで名前変えるかも。
 */
export const eSearch: ESearch = async <I extends EIndexName>(
  params: ESearchRequest<I>,
  options?: TransportRequestOptionsWithOutMeta
): Promise<SearchResponse | undefined> => {
  const token = await new TokenGetInteractor().handle();
  if (!token) {
    return undefined;
  }
  const res = await axios.post('/api/search', {
    es_token: token.es_token,
    request: {
      params,
      options,
    },
  });
  const result = res.data;
  console.log('search result', params, result, options);
  return result as SearchResponse;
};
